module.exports = {
  "name": "uk_UA",
  "day": {
    "abbrev": ["нд", "пн", "вт", "ср", "чт", "пт", "сб"],
    "full": ["неділя", "понеділок", "вівторок", "середа", "четвер", "п'ятниця", "субота"]
  },
  "month": {
    "abbrev": ["січ", "лют", "бер", "кві", "тра", "чер", "лип", "сер", "вер", "жов", "лис", "гру"],
    "full": ["січень", "лютий", "березень", "квітень", "травень", "червень", "липень", "серпень", "вересень", "жовтень", "листопад", "грудень"]
  },
  "meridiem": ["", ""],
  "date": "%d.%m.%y",
  "time24": "%T",
  "dateTime": "%a, %d-%b-%Y %X %z",
  "full": "%A, %-d %Om %Y %X %z",
  "time12": ""
};